var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.show
        },
        on: {
          close: _vm.close
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isActivated
                        ? "Two-Factor Enabled"
                        : "Two-factor Enrollment"
                    ) +
                    " "
                )
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _vm.preloading
                  ? _c("v-progress-linear", {
                      attrs: {
                        color: "green",
                        indeterminate: true
                      }
                    })
                  : _c("div", [
                      _vm.recovery_codes.length
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c("p", [_vm._v("Recovery Codes:")]),
                                      _c("p", [
                                        _vm._v(
                                          "Store these in a safe place! If you lose access to your 2FA device, using a recovery code to login will disable 2FA protection for your GreenGeeks account."
                                        )
                                      ]),
                                      _c(
                                        "ul",
                                        _vm._l(_vm.recovery_codes, function(
                                          code,
                                          index
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key: index
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(code))
                                              ]),
                                              _c(
                                                "gg-btn",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    icon: ""
                                                  },
                                                  on: {
                                                    click: function click(
                                                      $event
                                                    ) {
                                                      return _vm.copyToClipboard(
                                                        code
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        text: ""
                                                      }
                                                    },
                                                    [_vm._v("mdi-content-copy")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        0
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          attrs: {
                                            text: ""
                                          },
                                          on: {
                                            click: function click($event) {
                                              return _vm.copyToClipboard(
                                                _vm.recovery_codes
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Copy All")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass: "subtitle-1 mb-2"
                                        },
                                        [_vm._v("Enable Security Questions!")]
                                      ),
                                      _c("p", [
                                        _vm._v(
                                          " We strongly recommend enabling security questions to assist with account recovery in case your authenticator is ever lost. Account recovery options are limited without security questions enabled. "
                                        )
                                      ]),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "mb-0"
                                        },
                                        [
                                          _vm._v(
                                            " You may now configure security questions at the bottom of the Security section, below the Two-Factor Authentication status. "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              !_vm.isActivated
                                ? _c(
                                    "v-row",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        justify: "center"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "align-center text-center",
                                          attrs: {
                                            cols: "12",
                                            sm: "4",
                                            md: "4"
                                          }
                                        },
                                        [
                                          _vm.qrContent
                                            ? _c("vue-qrcode", {
                                                attrs: {
                                                  value: _vm.qrContent,
                                                  options: {
                                                    size: 180
                                                  }
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    type: "error",
                                    dismissible: "",
                                    transition: "fade-transition"
                                  },
                                  model: {
                                    value: _vm.showError,
                                    callback: function callback($$v) {
                                      _vm.showError = $$v
                                    },
                                    expression: "showError"
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.error_message) + " ")]
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      !_vm.isActivated
                                        ? _c("p", [
                                            _vm._v(
                                              " Scan the barcode above with your two-factor application, then enter the resulting six digital code. "
                                            )
                                          ])
                                        : _c("p", [
                                            _vm._v(
                                              " Enter a valid code from your two-factor application to disable two-factor authentication. "
                                            )
                                          ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-form",
                                {
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    }
                                  }
                                },
                                [
                                  _c("gg-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      outlined: "",
                                      required: "",
                                      name: "Code",
                                      "error-messages": _vm.errors.collect(
                                        "Code"
                                      ),
                                      label: "Code"
                                    },
                                    model: {
                                      value: _vm.validate_code,
                                      callback: function callback($$v) {
                                        _vm.validate_code = $$v
                                      },
                                      expression: "validate_code"
                                    }
                                  }),
                                  !_vm.isActivated
                                    ? _c("v-checkbox", {
                                        staticClass: "font-italic mt-0",
                                        attrs: {
                                          label: _vm.agreementLabel
                                        },
                                        model: {
                                          value: _vm.agreement,
                                          callback: function callback($$v) {
                                            _vm.agreement = $$v
                                          },
                                          expression: "agreement"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm.invalid_code
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "error--text"
                                    },
                                    [
                                      _vm._v(
                                        " Invalid token. Please try again using a valid recovery code or a code generated from your authentication device. "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                    ])
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _vm.recovery_codes.length
                  ? _c(
                      "div",
                      [
                        _c(
                          "gg-btn",
                          {
                            attrs: {
                              primary: "",
                              disabled: _vm.loading
                            },
                            on: {
                              click: _vm.closeSuccess
                            }
                          },
                          [_vm._v(" Close ")]
                        )
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c(
                          "gg-btn",
                          {
                            staticClass: "mr-2",
                            attrs: {
                              secondary: "",
                              disabled: _vm.loading
                            },
                            on: {
                              click: _vm.close
                            }
                          },
                          [_vm._v(" Cancel ")]
                        ),
                        !_vm.isActivated
                          ? _c(
                              "gg-btn",
                              {
                                attrs: {
                                  primary: "",
                                  disabled: !_vm.agreement,
                                  loading: _vm.loading
                                },
                                on: {
                                  click: _vm.enable2FA
                                }
                              },
                              [_vm._v(" Enable ")]
                            )
                          : _c(
                              "gg-btn",
                              {
                                attrs: {
                                  color: "red",
                                  primary: "",
                                  dark: "",
                                  loading: _vm.loading
                                },
                                on: {
                                  click: _vm.disable2FA
                                }
                              },
                              [_vm._v(" Disable ")]
                            )
                      ],
                      1
                    )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }